<template>
  <div class="scroll-body">
    <div class="jumbotron">
      <div class="row jumbotron-body">
        <div class="col--left">
          <div class="title row-align-center">
            <svg class="icon">
              <use xlink:href="#icon-smile" />
            </svg>
            <span>{{ $t('post.postAds') }}</span>
          </div>
          <p class="para" style="color:red;" >
            {{ $t('post.postDes', { rate: rate }) }}
          </p>
        </div>
        <img class="col--right" src="@/images/post/jumbotron-pic@2x.png" />
      </div>
      <div class="row jumbotron-footer">
        <md-button type="primary" class="btn-create" @click="onCreatePostClick">
          <div class="row-center">
            <svg class="icon">
              <use xlink:href="#icon-plus" />
            </svg>
            <span>{{ $t('post.postAnAd') }}</span>
          </div>
        </md-button>
      </div>
    </div>
    <div class="post-list" v-if="myAdsList.length">
      <div class="btn-switch">
        <md-button
          type="primary"
          plain
          inline
          @click="takeOnAll"
          v-if="hasResumeAds"
        >
          <div class="row-center">
            <svg class="icon"><use xlink:href="#icon-add" /></svg>
            <span class="text">{{ $t('post.listAll') }}</span>
          </div>
        </md-button>
        <md-button type="primary" plain inline @click="takeOffAll" v-else>
          <div class="row-center">
            <svg class="icon"><use xlink:href="#icon-remove" /></svg>
            <span class="text">{{ $t('post.delistAll') }}</span>
          </div>
        </md-button>
      </div>
      <md-tabs v-model="currentTab" @change="onTabChanged">
        <md-tab-pane
          name="sell"
          :label="$t('post.sell')"
          v-if="mySellAds.length"
        >
          <exchange-item
            v-for="(item, index) in mySellAds"
            :key="`sell-${index}`"
            :data="item"
            :class="{ inactive: item.status == 'off' }"
            show-attribute
            @click.native="goDetail(item.id)"
          />
        </md-tab-pane>

        <md-tab-pane name="buy" :label="$t('post.buy')" v-if="myBuyAds.length">
          <exchange-item
            v-for="(item, index) in myBuyAds"
            :key="`sell-${index}`"
            :data="item"
            :class="{ inactive: item.status == 'off' }"
            show-attribute
            @click.native="goDetail(item.id)"
          />
        </md-tab-pane>
      </md-tabs>
    </div>
  </div>
</template>

<script>
import {
  Button,
  Icon,
  ScrollView,
  Toast,
  TabPane,
  Tabs,
  Dialog,
} from 'mand-mobile';
import exchangeItem from '@/components/exchange-item';
import { mapState } from 'vuex';
import { takeOffAds, takeOnMyAds } from '@/api/user.js';
export default {
  components: {
    [Button.name]: Button,
    [Icon.name]: Icon,
    [ScrollView.name]: ScrollView,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    'exchange-item': exchangeItem,
  },
  computed: mapState({
    isLogin: state => state.isLogin,
    myAdsList: state => state.myAdsList,
    settings: state => state.settings,
    userInfo: state => state.userInfo,
    hasResumeAds: state => state.hasResumeAds,
    myBuyAds() {
      return this.myAdsList.filter(item => item.type === 'buy');
    },
    mySellAds() {
      return this.myAdsList.filter(item => item.type === 'sell');
    },
    rate() {
      return (
        this.userInfo.advertisementRate || this.settings.rate.advertisementRate
      );
    },
  }),
  data() {
    return {
      currentTab: 'sell',
    };
  },
  mounted() {
    const tab = window.localStorage.getItem('post_index_tab');
    let p1 = Promise.resolve(),
      p2 = Promise.resolve(),
      p3 = Promise.resolve();
    if (!this.settings.isSettingsLoaded) {
      p1 = this.$store.dispatch('updateSettings');
    }
    if (this.isLogin) {
      p2 = this.$store.dispatch('updateMyAdsList').then(() => {
        if (tab == 'sell' && this.mySellAds.length) {
          this.currentTab = 'sell';
        } else if (tab == 'buy' && this.myBuyAds.length) {
          this.currentTab = 'buy';
        } else {
          this.currentTab = this.mySellAds.length ? 'sell' : 'buy';
        }
      });
      p3 = this.$store.dispatch('updateResumeAdsStatus').catch(() => {});
    }
    Promise.all([p1, p2, p3]).catch(err => {
      Toast.hide();
      Toast.failed(`${this.$t('error.occur')}${err.message}`);
    });
  },
  methods: {
    onCreatePostClick() {
      this.$router.push('/post/create');

      //特殊处理，放到后台判断
      // if(this.userInfo.hasVerified || this.userInfo.isOversea){
      //   this.$router.push('/post/create');
      // }else{
      //   Dialog.alert({
      //     title: this.$t('common.notice'),
      //     content: this.$t('payInfo.noKycAlert'),
      //     confirmText: this.$t('common.confirm'),
      //   });
      // }
    },
    goDetail(id) {
      this.$router.push({
        path: '/post/detail',
        query: {
          id: id,
        },
      });
    },
    onTabChanged({ name }) {
      window.localStorage.setItem('post_index_tab', name);
    },
    takeOffAll() {
      Dialog.confirm({
        icon: 'warn',
        title: this.$t('post.delistAllAlert'),
        cancelText: this.$t('common.cancel'),
        confirmText: this.$t('common.confirm'),
        onConfirm: () => {
          Toast.loading(this.$t('common.loading'));
          takeOffAds()
            .then(() => {
              return Promise.all([
                this.$store.dispatch('updateMyAdsList'),
                this.$store.dispatch('updateResumeAdsStatus'),
              ]);
            })
            .then(() => {
              Toast.hide();
            })
            .catch(err => {
              Toast.hide();
              Dialog.alert({
                icon: 'fail',
                title: err.message,
                confirmText: this.$t('common.confirm'),
              });
            });
        },
      });
    },
    takeOnAll() {
      Dialog.confirm({
        icon: 'warn',
        title: this.$t('post.listAllAlert'),
        cancelText: this.$t('common.cancel'),
        confirmText: this.$t('common.confirm'),
        onConfirm: () => {
          Toast.loading(this.$t('common.loading'));
          takeOnMyAds()
            .then(() => {
              return Promise.all([
                this.$store.dispatch('updateMyAdsList'),
                this.$store.dispatch('updateResumeAdsStatus'),
              ]);
            })
            .then(() => {
              Toast.hide();
            })
            .catch(err => {
              Toast.hide();
              Dialog.alert({
                icon: 'fail',
                title: err.message,
                confirmText: this.$t('common.confirm'),
              });
            });
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.wrapper {
  height: 100%;
}

.scroll-body {
  padding: 9.6vw 4.8vw 0;
}

.jumbotron {
  & > .row {
    margin-bottom: 4.8vw;
  }

  .jumbotron-body {
    .col--left {
      flex-grow: 1;
      margin-right: 4.8vw;
    }

    .title {
      font-size: 4.8vw;
      font-weight: bold;
      line-height: 6.67vw;
    }

    .icon {
      icon-size(6.67vw);
      margin-right: 1.07vw;
    }

    .para {
      margin-top: 2.13vw;
    }

    .col--right {
      flex: 0 0 21.33vw;
      height: 25.6vw;
    }
  }

  .jumbotron-footer {
    .icon {
      margin-right: 1.07vw;
      icon-size(5.33vw);
      color: color-primary;
      background: #fff;
      border-radius: 1.68vw;
    }
  }
}

.post-list {
  margin-top: 4.8vw;
  padding-bottom: 60vw;
  position: relative;

  .btn-switch {
    position: absolute;
    right: 0;
    top: 0;
    z-index: 100;

    .md-button {
      min-width: 21.33vw;
      height: 5.87vw;
      font-size: 2.67vw;
    }

    .icon {
      margin-right: 1.07vw;
      width: 4.8vw;
      height: 4.8vw;
    }
  }

  & >>> {
    .md-tab-bar-start, .md-tab-bar-end {
      display: none;
    }

    .md-tab-bar-list {
      display: flex;
      justify-content: flex-start;
    }

    .md-tab-bar-item {
      margin: 0;
      padding: 0;
      flex: 0 0 16vw;
      font-size: 4.27vw;
      min-height: 6.4vw;

      &.is-active {
        font-size: 4.8vw;
        font-weight: 600;
        color: #2C3133;
      }
    }

    .md-tab-bar-ink {
      height: 1.07vw;
      bottom: 1.07vw;
      background-color: rgba(color-primary, 0.3);
    }
  }

  .exchange-item.inactive {
    filter: grayscale(1);
  }
}
</style>
